import FragmentsListEditor from './FragmentsListEditor'

export default FragmentsListEditor
